import { useEventEmitter } from 'ahooks'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { RequestedCommentFragment } from '@/generated/graphql'

import { PostCommentTextarea } from './post-comment-textarea.component'
import { useUpdateComment } from './post-comment.hooks'
import s from './post-comments.module.less'

interface PostCommentEditProps {
  comment: RequestedCommentFragment
  onClose: () => void
}

export const PostCommentEdit: React.FC<PostCommentEditProps> = ({ comment, onClose }) => {
  const [t] = useTranslation()
  const [updateComment, { loading }] = useUpdateComment()
  const onChangeContent$ = useEventEmitter<string | null>()

  const onSubmit = async (content: string) => {
    await updateComment({
      variables: {
        comment: {
          commentId: comment.commentId,
          content,
        },
      },
    })
    onClose()
  }

  return (
    <div className={s.editComment}>
      <PostCommentTextarea
        content={comment.content}
        autoFocus
        loading={loading}
        placeholder={comment.parentCommentId ? t('post.replyComment') : t('post.writeComment')}
        onSubmit={onSubmit}
        onEsc={onClose}
        onChangeContent$={onChangeContent$}
      />
      <div className={s.editActions}>
        按 Esc <a onClick={onClose}>取消。</a>
      </div>
    </div>
  )
}
